export default "__VITE_PUBLIC_ASSET__fcef3492__"